// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';

// --- HS Code
import { CommunicationsBaseService } from './communications-base.service';
import { environment } from '../../../../environments/environment';
import { UserCommunicationsModel, ApplicationError, PatchModel } from '../../../models';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';
import { PatchOperations } from 'src/app/models/common/patch-operations';

// #endregion


@Injectable({
  providedIn: 'root'
})
export class CommunicationsService extends CommunicationsBaseService {

  constructor(private http: HttpClient, private appService: AppService, private translate: TranslateService) {
    super();
  }

  loadUserCommunicationPreferences(): void {
    const url = environment.apiConfig.baseUrl + environment.apiConfig.communicationsApi;

    this.http.get<UserCommunicationsModel>(url).pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._modelError.bind(this))
    ).subscribe(ucm => {
      this._showSurveyNotifications$.next(ucm.showSurveyNotifications);
      this._showUpdatesInspirationOffers$.next(ucm.showUpdatesInspirationOffers);
    });
  }

  setShowSurveyNotifications(value: boolean): void {
    if (value === null || typeof value === 'undefined') {
      return;
    }

    this._updateCommunicationSetting(value, 'ShowSurveyUpdates');
  }

  setShowUpdates(value: boolean): void {
    if (value === null || typeof value === 'undefined') {
      return;
    }

    this._updateCommunicationSetting(value, 'ShowUpdatesInspirationOffers');
  }

  private _updateCommunicationSetting(value: boolean, valueToUpdate: string) {
    const url = environment.apiConfig.baseUrl + environment.apiConfig.communicationsApi;
    const model = {
      operation: PatchOperations.replace,
      path: valueToUpdate,
      value: value.toString()
    } as PatchModel;

    this.http.patch<UserCommunicationsModel>(url, model).pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._modelError.bind(this))
    ).subscribe(ucm => {
      this._showSurveyNotifications$.next(ucm.showSurveyNotifications);
      this._showUpdatesInspirationOffers$.next(ucm.showUpdatesInspirationOffers);
    });
  }

  private _modelError(err, caught) {
    this._handleError(err);
    return of(null as UserCommunicationsModel);
  }

  private _handleError(err) {
    this.appService.setLoading(false);

    let error: ApplicationError;
    if (err && err instanceof HttpErrorResponse) {
      // A client-side or network error occurred. Handle it accordingly.
      let detailedMessage = `${err.message}`;
      if (err.statusText) {
        detailedMessage += `<br/>${err.statusText}`;
      }
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        errorNumber: err.status,
        detailedMessage
      } as ApplicationError;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        originalError: err
      } as ApplicationError;
    }
    this.appService.setLastError(error);
  }

}
